import { render, staticRenderFns } from "./BizProductReport.vue?vue&type=template&id=71a9770d&"
import script from "./BizProductReport.vue?vue&type=script&lang=js&"
export * from "./BizProductReport.vue?vue&type=script&lang=js&"
import style0 from "./BizProductReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports